import request from "@/utils/request";
import qs from "qs";

/**
 * 查询项目信息
 *
 * @param param
 */
export function getProjectInfo(projectId) {
  return request.get(`/v2/eval/project/info/${projectId}`);
}

/**
 * 根据项目id获取方案信息
 *
 * @param param
 */
export function getSchemeInfo(projectId) {
  return request.get(`/v2/eval/project/scheme/info/${projectId}`);
}

/**
 * 查询项目报告
 *
 * @param param
 */
export function getReportInfo(projectId) {
  return request.get(`/v2/eval/report/info/${projectId}`);
}
/**
 * 查询试卷列表
 *
 * @param param
 */
export function getPaperInfo(projectId) {
  return request.get(`/v2/eval/paper/info/${projectId}`);
}
/**
 * 查询已经答完试卷Id
 *
 * @param param
 */
export function getPaperOverIds(projectId) {
  return request.get(`/v2/eval/paper/over/${projectId}`);
}

/**
 * 查询项目未作试卷
 *
 * @param param
 */
export function getUndoPaperInfo(projectId) {
  return request.get(`/v2/eval/paper/undo/${projectId}`);
}

/**
 * 下一题
 *
 * @param param
 */
export function doNext(data) {
  return request.post(`/v2/eval/do/next`, data || {});
}

/**
 * 查询岗位选择试卷的记录
 *
 * @param param
 */
export function getPostRecord(projectId) {
  return request.get(`/v2/eval/post/${projectId}`);
}

/**
 * 交卷
 *
 * @param param
 */
export function doFinish(data) {
  return request.post(`/v2/eval/do/finish`, data || {});
}

/**
 * 保存用户基本信息
 * @param param
 */
export function submitInfo(projectId, data) {
  return request.post(`/v2/eval/info/sumbit/${projectId}`, data || {});
}

/**
 * 创建支付订单
 * @param param
 */
export function createOrder(projectId) {
  return request.post(`/v2/eval/order/create/${projectId}`);
}

/**
 * 查询订单
 * @param param
 */
export function fetchOrderByProjectId(projectId) {
  return request.get(`/v2/eval/order/fetch/${projectId}`);
}

/**
 * 获取微信支付签名
 * @param param
 */
export function getPaySignature(projectId, order) {
  return request.post(`/v2/eval/order/signature/${projectId}`, order);
}

/**
 * 修改报告支付状态
 * @param param
 */
export function updateProjectPaid(projectId) {
  return request.post(`/v2/eval/report/pay/${projectId}`);
}


/**
 * 获取所有行业分类
 * @param param
 */
export function findCategoryAll() {
  return request.get(`/v2/eval/category/all`);
}

/**
 * 获取分类下面所有的岗位
 * @param param
 */
export function findPostByCatId(catId) {
  return request.get(`/v2/eval/post/category/${catId}`);
}

/**
 * 获取客户下面的岗位
 * @param param
 */
export function findPostByCusId(cusId) {
  return request.get(`/v2/eval/post/customer/${cusId}`);
}

/**
 * 根据试卷id获取所有试题
 * @param param
 */
export function findQue(projectId) {
  return request.get(`/v2/eval/question/post/${projectId}`);
}

/**
 * 根据项目获取用户的报告
 * @param projectId
 */
export function getReport(projectId) {
  return request.get(`/v2/eval/report/${projectId}`);
}



/**
 * 校验码
 * @param projectId
 */
export function checkPassword(projectId,code) {
  return request.post(`/v2/eval/valid/${projectId}`,qs.stringify(code));
}


